import styled from 'styled-components';

export const ListPickerItemWrapper = styled.div`
  max-width: 95%;

  & + & {
    margin-top: 8px;
  }
`;

export const ListPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 16px;
`;

export const Title = styled.span``;

export const Subtitle = styled.span`
  display: block;
  font-style: italic;
`;
